export { default as React, Component, useEffect, useState } from 'react';
export { useRouter } from "next/router";
export { format, addDays, subDays, isSameDay, startOfWeek, lastDayOfWeek, addWeeks, subWeeks, isSameMonth,  addMonths, subMonths, startOfMonth, endOfMonth } from "date-fns";
export { nb, enUS, sv, da } from 'date-fns/locale';

// ------------------- ICONS -------------------
export { default as ChevronLeftRed } from 'public/icons/chevron-red-left.svg';
export { default as ChevronRightRed } from 'public/icons/chevron-red-right.svg';
// ------------------- ICONS -------------------


// ------------------- STYLESHEET -------------------
export {CalendarAction} from '@/actions/components/calendar/calendar';
export {CommonAction} from "@/actions/common/common";
export {useTranslation} from "@/imports-files/common/common";

export {CalandarService} from '@/services/components/calendar/calendar';

export { default as PageStyle } from "@/styles/components/calendar/_index.module.scss";

// ------------------- STYLESHEET -------------------
